import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';

// Mentions Légales
export const MentionsLegales = () => {
  return (
    <>
      <Helmet>
        <title>Mentions Légales | Olney Tech Solutions</title>
        <meta name="description" content="Mentions légales du site Olney Tech Solutions - Agence web à Lille, Roncq, Phalempin." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl font-bold text-white mb-8 font-['Space_Grotesk']">
              Mentions Légales
            </h1>

            <div className="prose prose-invert prose-lg max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-white mb-4">1. Éditeur du site</h2>
                <div className="glass-panel rounded-2xl p-6">
                  <p className="text-gray-300">
                    <strong>Olney Tech Solutions</strong><br />
                    Entreprise individuelle<br />
                    Siège social : Roncq, 59223, France<br />
                    Téléphone : 06 89 17 73 85<br />
                    Email : contact@olney.dev<br />
                    SIRET : [En cours d'immatriculation]
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">2. Directeur de la publication</h2>
                <p className="text-gray-400">
                  Anthony Vanheule, en qualité de gérant d'Olney Tech Solutions.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">3. Hébergement</h2>
                <div className="glass-panel rounded-2xl p-6">
                  <p className="text-gray-300">
                    <strong>Vercel Inc.</strong><br />
                    340 S Lemon Ave #4133<br />
                    Walnut, CA 91789, USA<br />
                    https://vercel.com
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">4. Propriété intellectuelle</h2>
                <p className="text-gray-400">
                  L'ensemble du contenu de ce site (textes, images, logos, vidéos, etc.) est protégé par le droit d'auteur.
                  Toute reproduction, même partielle, est interdite sans autorisation préalable écrite d'Olney Tech Solutions.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">5. Données personnelles</h2>
                <p className="text-gray-400">
                  Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.
                  Pour exercer ces droits, contactez-nous à : contact@olney.dev
                </p>
                <p className="text-gray-400 mt-2">
                  Pour plus d'informations, consultez notre{' '}
                  <a href="/confidentialite" className="text-[var(--primary)] underline">
                    Politique de Confidentialité
                  </a>.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">6. Cookies</h2>
                <p className="text-gray-400">
                  Ce site utilise des cookies techniques nécessaires à son fonctionnement et des cookies d'analyse
                  (Vercel Analytics) pour améliorer votre expérience. Vous pouvez les désactiver dans les paramètres
                  de votre navigateur.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">7. Liens externes</h2>
                <p className="text-gray-400">
                  Ce site peut contenir des liens vers des sites externes. Olney Tech Solutions décline toute responsabilité
                  quant au contenu de ces sites tiers.
                </p>
              </section>

              <p className="text-gray-500 text-sm mt-12">
                Dernière mise à jour : Décembre 2024
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

// Politique de Confidentialité
export const Confidentialite = () => {
  return (
    <>
      <Helmet>
        <title>Politique de Confidentialité | Olney Tech Solutions</title>
        <meta name="description" content="Politique de confidentialité et protection des données personnelles - Olney Tech Solutions." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl font-bold text-white mb-8 font-['Space_Grotesk']">
              Politique de Confidentialité
            </h1>

            <div className="prose prose-invert prose-lg max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-white mb-4">1. Introduction</h2>
                <p className="text-gray-400">
                  Olney Tech Solutions s'engage à protéger la vie privée des utilisateurs de son site.
                  Cette politique explique comment nous collectons, utilisons et protégeons vos données personnelles.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">2. Données collectées</h2>
                <p className="text-gray-400">Nous collectons les données suivantes :</p>
                <ul className="list-disc list-inside text-gray-400 mt-2 space-y-2">
                  <li>Données de contact (nom, email, téléphone) via le formulaire de contact</li>
                  <li>Données de navigation (adresse IP, pages visitées) via les cookies analytiques</li>
                  <li>Messages échangés via le chatbot</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">3. Finalités du traitement</h2>
                <p className="text-gray-400">Vos données sont utilisées pour :</p>
                <ul className="list-disc list-inside text-gray-400 mt-2 space-y-2">
                  <li>Répondre à vos demandes de contact et devis</li>
                  <li>Améliorer notre site et nos services</li>
                  <li>Vous envoyer des informations commerciales (avec votre consentement)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">4. Base légale</h2>
                <p className="text-gray-400">
                  Le traitement de vos données repose sur votre consentement (formulaire de contact, newsletter)
                  et notre intérêt légitime (amélioration des services).
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">5. Durée de conservation</h2>
                <div className="glass-panel rounded-2xl p-6">
                  <ul className="text-gray-300 space-y-2">
                    <li>Données de contact : 3 ans après le dernier contact</li>
                    <li>Données de navigation : 13 mois</li>
                    <li>Messages chatbot : 90 jours</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">6. Vos droits</h2>
                <p className="text-gray-400">Conformément au RGPD, vous disposez des droits suivants :</p>
                <ul className="list-disc list-inside text-gray-400 mt-2 space-y-2">
                  <li>Droit d'accès à vos données</li>
                  <li>Droit de rectification</li>
                  <li>Droit à l'effacement (« droit à l'oubli »)</li>
                  <li>Droit à la portabilité</li>
                  <li>Droit d'opposition</li>
                  <li>Droit de retirer votre consentement</li>
                </ul>
                <p className="text-gray-400 mt-4">
                  Pour exercer ces droits : contact@olney.dev
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">7. Sécurité</h2>
                <p className="text-gray-400">
                  Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger
                  vos données : chiffrement SSL/TLS, accès restreint, sauvegardes sécurisées.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">8. Transferts de données</h2>
                <p className="text-gray-400">
                  Certaines données peuvent être transférées vers des prestataires situés hors UE (Vercel aux USA).
                  Ces transferts sont encadrés par des clauses contractuelles types approuvées par la Commission européenne.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">9. Contact DPO</h2>
                <p className="text-gray-400">
                  Pour toute question relative à la protection de vos données :<br />
                  Email : contact@olney.dev<br />
                  Vous pouvez également introduire une réclamation auprès de la CNIL.
                </p>
              </section>

              <p className="text-gray-500 text-sm mt-12">
                Dernière mise à jour : Décembre 2024
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

// Conditions Générales de Vente
export const CGV = () => {
  return (
    <>
      <Helmet>
        <title>Conditions Générales de Vente | Olney Tech Solutions</title>
        <meta name="description" content="Conditions générales de vente des services Olney Tech Solutions." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl font-bold text-white mb-8 font-['Space_Grotesk']">
              Conditions Générales de Vente
            </h1>

            <div className="prose prose-invert prose-lg max-w-none space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-white mb-4">1. Objet</h2>
                <p className="text-gray-400">
                  Les présentes CGV régissent les relations contractuelles entre Olney Tech Solutions
                  et ses clients pour toute prestation de services en développement web, maintenance,
                  référencement et conseil informatique.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">2. Devis et commande</h2>
                <p className="text-gray-400">
                  Tout projet fait l'objet d'un devis détaillé gratuit. La commande est considérée comme
                  ferme et définitive après acceptation du devis par le client (signature ou validation
                  par email) et versement de l'acompte.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">3. Prix et paiement</h2>
                <div className="glass-panel rounded-2xl p-6 space-y-4">
                  <p className="text-gray-300">
                    <strong>Acompte :</strong> 30% à la commande<br />
                    <strong>Solde :</strong> À la livraison du projet
                  </p>
                  <p className="text-gray-300">
                    <strong>Moyens de paiement acceptés :</strong><br />
                    Virement bancaire, chèque, espèces (jusqu'à 1000€)
                  </p>
                  <p className="text-gray-300">
                    <strong>Facilités de paiement :</strong><br />
                    Paiement en 3 fois sans frais possible pour les projets > 2000€
                  </p>
                  <p className="text-gray-400 text-sm">
                    TVA non applicable, article 293 B du CGI.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">4. Délais</h2>
                <p className="text-gray-400">
                  Les délais de réalisation sont indiqués dans le devis. Ils débutent à réception
                  de l'acompte et des éléments nécessaires (contenu, images, accès).
                  En cas de retard imputable au client, les délais sont prolongés d'autant.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">5. Obligations du client</h2>
                <ul className="list-disc list-inside text-gray-400 space-y-2">
                  <li>Fournir les éléments nécessaires dans les délais convenus</li>
                  <li>Valider les étapes du projet (maquettes, développement)</li>
                  <li>Respecter les échéances de paiement</li>
                  <li>Garantir la légalité des contenus fournis</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">6. Propriété intellectuelle</h2>
                <p className="text-gray-400">
                  Le transfert des droits de propriété intellectuelle s'effectue au paiement intégral.
                  Olney Tech Solutions conserve le droit de mentionner le projet dans son portfolio,
                  sauf demande contraire du client.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">7. Garantie</h2>
                <div className="glass-panel rounded-2xl p-6">
                  <ul className="text-gray-300 space-y-2">
                    <li><strong>Garantie de conformité :</strong> Correction gratuite des bugs pendant 6 mois</li>
                    <li><strong>Support post-livraison :</strong> 1 à 3 mois selon le forfait</li>
                    <li><strong>Modifications mineures :</strong> Incluses dans le forfait maintenance</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">8. Résiliation</h2>
                <p className="text-gray-400">
                  En cas de résiliation par le client en cours de projet, les sommes versées restent
                  acquises à Olney Tech Solutions. Une facturation complémentaire peut être effectuée
                  pour le travail réalisé.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">9. Responsabilité</h2>
                <p className="text-gray-400">
                  Olney Tech Solutions s'engage à apporter tout le soin et la diligence nécessaires
                  à la réalisation des prestations. Sa responsabilité est limitée au montant des
                  sommes perçues pour la prestation concernée.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-white mb-4">10. Litiges</h2>
                <p className="text-gray-400">
                  En cas de litige, les parties s'engagent à rechercher une solution amiable.
                  À défaut, le tribunal compétent sera celui de Lille.
                </p>
              </section>

              <p className="text-gray-500 text-sm mt-12">
                Dernière mise à jour : Décembre 2024
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};
